import React from 'react';

export const TableRowInput = ({ title, type, name, value }) => (
    <tr>
        <th>{title}</th>
        <td>
            <input type={type} className="input-no-border form-control" name={name} value={value}  />
        </td>
    </tr>
);


// WEBPACK FOOTER //
// ./Public/src/js/component/anulacion/children/tr-input.jsx